import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ThemeProvider } from "styled-components";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import { Theme } from "../../appConfig";
import { CompetenceActions } from "../competence/redux/competence.reducer";
import { CheckAuthLayout } from "../../components";
import { useModuleConfig, ModuleType } from "../";
import { NotFoundPage } from "../../app/notFoundPage/notFoundPage.component";

import { StatisticsTheme } from "./views/statistics/statistics.constants";
import { IndicatorsTabURI, IndicatorsTabName } from "./teamIndicators.constants";
import {
  Container,
  HeaderWrapper,
  HeaderBox,
  ContentWrapper,
  Header,
  Tabs,
  Tab,
  TabText,
} from "./teamIndicators.styled";
import { teamIndicatorsRoutes } from './teamIndicators.routes';

const TeamIndicators = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const config = useModuleConfig(ModuleType.TeamIndicators);
  const activeTab = location.pathname.replace(`${config.urls[1]}/`, "");

  useEffect(() => {
    dispatch(CompetenceActions.getUserCompetenceList());
  }, [dispatch]);

  useEffect(() => {
    if (config.urls.includes(location.pathname)) {
      navigate(IndicatorsTabURI.Strategic, { replace: true });
    }
  }, [navigate, location.pathname]);

  const renderTabLink = (tab) => {
    if (Theme.StatisticsTheme === StatisticsTheme.Hidden && tab === IndicatorsTabURI.Statistics) {
      return null;
    }

    const currentTab = tab === activeTab;

    return (
      <Tab to={tab} disabled={currentTab}>
        <TabText active={currentTab}>
          {t(`teamIndicators.tabs.${IndicatorsTabName[tab]}`)}
        </TabText>
      </Tab>
    );
  };

  const renderTabContent = () => (
    <ContentWrapper>
      <Routes>
        <Route element={<CheckAuthLayout />}>
          {teamIndicatorsRoutes.map((route) =>
            Object.values(route.pathSettings.urls).map((url, index) => {
              const Component = route.component;

              return (
                <Route
                  key={`${url}-${index}`}
                  path={url}
                  element={<Component />}
                />
              );
            })
          )}
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ContentWrapper>
  );

  return (
    <ThemeProvider theme={config.theme}>
      <Container>
        <HeaderWrapper>
          <HeaderBox>
            <Header>{t(config.label)}</Header>
            <Tabs>
              {renderTabLink(IndicatorsTabURI.Strategic)}
              {renderTabLink(IndicatorsTabURI.Common)}
              {renderTabLink(IndicatorsTabURI.Statistics)}
            </Tabs>
          </HeaderBox>
        </HeaderWrapper>
        {renderTabContent()}
      </Container>
    </ThemeProvider>
  );
};

export default TeamIndicators;
